import classNames from 'classnames';
import * as React from 'react';
const TabsItem = ({ className, isActive, isMore, href, onClick = () => void 0, children, }) => {
    const Tag = href ? 'a' : 'button';
    const linkClasses = classNames(className, 'ixu-tabs__link', {
        'is-active': isActive,
        'ixu-tabs__link--more': isMore,
    });
    return (React.createElement("li", { className: "ixu-tabs__item" },
        React.createElement(Tag, { className: linkClasses, href: !!href ? href : undefined, onClick: onClick }, children)));
};
export default TabsItem;
//# sourceMappingURL=TabsItem.js.map